import type { FC } from "react";
import { MetaAdsDistanceUnit, type MetaAdsLocationPin } from "shared";
import { getPinColor } from "./GeoTargetingMap";

const RADIUS_PRESETS = [5, 10, 15, 25];

interface Props {
	pins: MetaAdsLocationPin[];
	onUpdatePin: (pinId: string, updates: Partial<MetaAdsLocationPin>) => void;
	onRemovePin: (pinId: string) => void;
}

export const LocationPinList: FC<Props> = ({
	pins,
	onUpdatePin,
	onRemovePin,
}) => {
	if (pins.length === 0) {
		return (
			<p className="text-muted" style={{ fontSize: 13 }}>
				Search for an address or click on the map to add locations.
			</p>
		);
	}

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
			{pins.map((pin, index) => (
				<div
					key={pin.id}
					style={{
						padding: 12,
						borderRadius: 8,
						border: "1px solid #dee2e6",
						background: "#fff",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 8,
							marginBottom: 8,
						}}
					>
						<div
							style={{
								width: 12,
								height: 12,
								borderRadius: "50%",
								background: getPinColor(index),
								flexShrink: 0,
							}}
						/>
						<span
							style={{
								flex: 1,
								fontSize: 13,
								overflow: "hidden",
								textOverflow: "ellipsis",
								whiteSpace: "nowrap",
							}}
							title={pin.label}
						>
							{pin.label}
						</span>
						<button
							type="button"
							className="btn btn-sm btn-outline-danger"
							style={{ padding: "2px 6px", lineHeight: 1 }}
							onClick={() => onRemovePin(pin.id)}
							title="Remove location"
						>
							<span
								className="material-symbols-rounded"
								style={{ fontSize: 16 }}
							>
								delete
							</span>
						</button>
					</div>

					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 8,
							marginBottom: 6,
						}}
					>
						<input
							type="range"
							min={1}
							max={50}
							value={pin.radius}
							onChange={(e) =>
								onUpdatePin(pin.id, { radius: Number(e.target.value) })
							}
							style={{ flex: 1 }}
						/>
						<input
							type="number"
							className="form-control form-control-sm"
							style={{ width: 64 }}
							min={1}
							max={50}
							value={pin.radius}
							onChange={(e) =>
								onUpdatePin(pin.id, { radius: Number(e.target.value) || 1 })
							}
						/>
					</div>

					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 4,
							flexWrap: "wrap",
						}}
					>
						{RADIUS_PRESETS.map((preset) => (
							<button
								key={preset}
								type="button"
								className={`btn btn-sm ${pin.radius === preset ? "btn-primary" : "btn-outline-secondary"}`}
								style={{ padding: "1px 8px", fontSize: 12 }}
								onClick={() => onUpdatePin(pin.id, { radius: preset })}
							>
								{preset}
							</button>
						))}
						<div style={{ marginLeft: "auto" }}>
							<div className="btn-group btn-group-sm">
								<button
									type="button"
									className={`btn ${pin.distanceUnit === MetaAdsDistanceUnit.MILE ? "btn-primary" : "btn-outline-secondary"}`}
									style={{ padding: "1px 8px", fontSize: 12 }}
									onClick={() =>
										onUpdatePin(pin.id, {
											distanceUnit: MetaAdsDistanceUnit.MILE,
										})
									}
								>
									mi
								</button>
								<button
									type="button"
									className={`btn ${pin.distanceUnit === MetaAdsDistanceUnit.KILOMETER ? "btn-primary" : "btn-outline-secondary"}`}
									style={{ padding: "1px 8px", fontSize: 12 }}
									onClick={() =>
										onUpdatePin(pin.id, {
											distanceUnit: MetaAdsDistanceUnit.KILOMETER,
										})
									}
								>
									km
								</button>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};
